// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"5c108bbc","232":"5c108bbc","402":"87b28e4d","865":"98090aaa"}[chunkId] + ".chunk.css";
};